<h2 mat-dialog-title class="text-center title p-2">{{title}}</h2>
<div class="buttons-top">
  <button mat-mini-fab class="btn-gray" mat-dialog-close>X</button>
</div>
<mat-dialog-content class="mat-typography">
  <div class="row">
    <div [innerHTML]="description" class="col-12 p-3"></div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="pb-3 d-flex justify-content-center"></mat-dialog-actions>
